/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimePayrunCreateCtrl
 */
angular.module('mercury.modules.time.payroll.payrun')
.controller('TimePayrollPayrunCreateCtrl', ["$scope", "$state", "TimePayrollPayruns", function($scope, $state, TimePayrollPayruns) {
  var frequency = 0;

  function setDefaults(startTime) {
    $scope.newStart = startTime;
    switch (frequency) {
      case 0:
        $scope.newEnd = moment(startTime).add(1, 'week').format();
      break;
      case 1:
        $scope.newEnd = moment(startTime).add(2, 'week').format();
      break;
      case 2:
        $scope.newEnd = moment(startTime).add(1, 'month').format();
      break;
    }
    $scope.newPaymentDate = moment($scope.newEnd).add(1, 'day').format();
  }

  $scope.loading = TimePayrollPayruns.getLast();
  $scope.loading.then(function(result) {
    if (result[0]) {
      frequency = result[0].frequency;
      setDefaults(result[0].datestampEnd);
    } else {
      var lastWeekStart = moment().mStartOf('week').subtract(1, 'week').format();
      setDefaults(lastWeekStart);
    }
  });

  $scope.confirmCreate = function() {
    $scope.$close();

    $state.go('Time.Payroll.PayrunCreate', {
      start: $scope.newStart,
      end: $scope.newEnd,
      payment: $scope.newPaymentDate,
      frequency: frequency
    });
  };
}]);
